var render = function render(){var _vm=this,_c=_vm._self._c;return _c('download-excel',{staticClass:"export-excel-wrapper",attrs:{"data":_vm.json_data,"fields":_vm.json_fields,"name":_vm.name}},[_c('button',{staticClass:"derive_but",on:{"click":_vm.judge_length}},[_vm._v("导出已选择媒体")])])
}
var staticRenderFns = []

export { render, staticRenderFns }